import { StatusChip } from "$components/chip";
import { PaymentStatus } from "elephant-web/gql";
import type { ComponentProps } from "react";
import { useIntl } from "react-intl";

const CHIP_STATUS: Record<
  PaymentStatus,
  ComponentProps<typeof StatusChip>["status"]
> = {
  [PaymentStatus.Paid]: "valid",
  [PaymentStatus.Expired]: "invalid",
  [PaymentStatus.Unpaid]: "disabled",
};

const PaymentStatusChip: FC<{ status: string }> = ({ status }) => {
  const { formatMessage } = useIntl();

  const label = {
    [PaymentStatus.Paid]: () =>
      formatMessage({
        id: "patient.pay.registrationFeeStatus.paid",
        defaultMessage: "Paid",
      }),
    [PaymentStatus.Unpaid]: () =>
      formatMessage({
        id: "patient.pay.registrationFeeStatus.notPaid",
        defaultMessage: "Not Paid",
      }),
    [PaymentStatus.Expired]: () =>
      formatMessage({
        id: "patient.pay.registrationFeeStatus.expired",
        defaultMessage: "Expired",
      }),
  }[status]();

  return <StatusChip label={label} status={CHIP_STATUS[status]} />;
};

export default PaymentStatusChip;
